import React, { useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//import { RootState } from 'src/redux/store';
import { useAppSelector } from "src/redux/hooks";
import {
  cartListDeleteRequest,
  orderSummaryRequest,
} from "src/redux/slices/labTestSlice";
import { TestItemInCart } from "src/types/labTests.types";
import Layout from "src/components/app/layout/Layout";
import Button from "src/components/app/Button";
import { CheckCircle } from "lucide-react";
// import { RootState } from 'src/redux/store'; // Adjust this path based on your store setup
// import * as actions from 'src/redux/slices';
// import { handlePageViewEvent } from 'src/helpers/analytics/Events/common';
// import { Constants } from 'src/constants';
// import Button from 'src/components/atoms/Button/Button';
// import { Icons } from 'src/constants/icons'; // Assume SVG component for Success icon

const CongratulationScreen: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const bookTestState = useAppSelector((state) => state.labTest.bookTest.data);
  const cartDetails = useAppSelector((state) => state.labTest.cartState.data);
  const cartListDeleteLoading = useAppSelector(
    (state) => state.labTest.getLabTestCart.isLoading
  );
  const orderSummaryState = useAppSelector(
    (state) => state.labTest.orderSummary
  );
  //const labListTestData = location.state?.labListTestData ?? [];
  const params = useParams();
  const supportProgramKey = params["support-program-key"];

  const onPressContinue = () => {
    if (cartDetails) {
      clearAllLabTestFromCart();
    } else {
      navigate(`/app/${supportProgramKey}/book-lab-test/order-details`, {
        state: {
          order_master_id: location?.state?.order_master_id,
        },
      });
    }
  };

  useEffect(() => {
    const payload = {
      order_master_id:
        location?.state?.order_master_id || bookTestState?.order_master_id,
    };
    new Promise((resolve, reject) => {
      dispatch(orderSummaryRequest({ resolve, reject, payload }));
    });
  }, []);

  //   useEffect(() => {
  //     if (labListTestData.length > 0) {
  //       deleteLabTestFromCart();
  //     }
  //   }, [labListTestData]);

  const clearAllLabTestFromCart = () => {
    const payload = {
      code:
        cartDetails?.tests_list.map((a: TestItemInCart) => a?.code).join(",") ??
        "",
    };
    new Promise((resolve, reject) => {
      dispatch(cartListDeleteRequest({ resolve, reject, payload }));
    }).finally(() => {
      navigate(`/app/${supportProgramKey}/book-lab-test/order-details`);
    });
  };

  //   useEffect(() => {
  //     handlePageViewEvent(Constants.SCREEN_NAME.CongratulationScreen);
  //   }, []);

  return (
    <Layout supportProgramKey={supportProgramKey || ""}>
      <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
        {!orderSummaryState?.isLoading && (
          <div className="flex flex-col items-center text-center">
            <CheckCircle className="w-20 h-20 text-green-500" />
            <h1 className="text-lg font-bold text-gray-800 mt-4">
              Congratulations!
            </h1>
            <p className="text-sm text-gray-500 mt-2 max-w-md">
              Your payment is successful, and the phlebotomist will be assigned
              to you before your sample pickup slot.
            </p>
            <div className="mt-6 w-full max-w-sm">
              <Button
                rounded="full"
                onClick={onPressContinue}
                fullWidth
                loading={cartListDeleteLoading}
              >
                Continue
              </Button>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default CongratulationScreen;
